export const routes = (parentName) => {
  return [
    {
      path: "video",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-Video-List`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-Video-New`,
          component: () => import("./Upsert.vue"),
        },
        {
          path: "cat/new",
          name: parentName + "-" + "VideoCat-New",
          component: () => import("./View.vue"),
        },

        {
          path: "cat",
          name: parentName + "-" + "VideoCat-List",
          component: () => import("./List.vue"),
        },
        {
          path: ":id/edit",
          name: parentName + "-" + "Video-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
